import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, MessageCircle, MapPin, Send } from 'lucide-react';

const ContactPage = () => {
  const [sent, setSent] = useState(false);

  return (
    <div className="bg-[#F8FAFC] min-h-screen font-['Onest']">
        {/* Navbar Simple */}
      <nav className="bg-white border-b border-slate-100 h-20 flex items-center">
        <div className="container mx-auto px-6">
          <Link to="/" className="text-4xl font-semibold text-emerald-800">mikropedia</Link>
        </div>
      </nav>

      <main className="container mx-auto px-6 py-16">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-16">
          
          <div>
            <h1 className="text-4xl font-black text-slate-900 mb-6">Hubungi <span className="text-emerald-800">Kami</span></h1>
            <p className="text-slate-500 mb-10 text-lg">Punya pertanyaan atau masukan? Kami senang mendengar dari Anda.</p>
            
            <div className="space-y-6">
              {[
                { icon: <Mail />, label: "Email", val: "auxindo.app@gmail.com" },
                { icon: <MessageCircle />, label: "WhatsApp", val: "+62 81806504100" },
                { icon: <MapPin />, label: "Kantor", val: "Jakarta, Indonesia" }
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-4 group">
                  <div className="w-12 h-12 rounded-2xl bg-white border border-slate-100 flex items-center justify-center text-emerald-800 group-hover:bg-emerald-800 group-hover:text-white transition-all">
                    {item.icon}
                  </div>
                  <div>
                    <p className="text-[10px] font-black uppercase text-slate-400 tracking-widest">{item.label}</p>
                    <p className="font-bold text-slate-700">{item.val}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white p-8 md:p-10 rounded-[2.5rem] border border-slate-100 shadow-xl shadow-slate-200/50">
            {!sent ? (
              <form className="space-y-5" onSubmit={(e) => {e.preventDefault(); setSent(true)}}>
                <div>
                  <label className="block text-xs font-bold uppercase text-slate-400 mb-2 ml-1">Nama Lengkap</label>
                  <input type="text" className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none focus:border-emerald-800 transition-all font-bold" placeholder="Masukkan nama..." required />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase text-slate-400 mb-2 ml-1">Email</label>
                  <input type="email" className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none focus:border-emerald-800 transition-all font-bold" placeholder="email@contoh.com" required />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase text-slate-400 mb-2 ml-1">Pesan</label>
                  <textarea rows="4" className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl outline-none focus:border-emerald-800 transition-all font-bold" placeholder="Apa yang bisa kami bantu?" required></textarea>
                </div>
                <button className="w-full bg-emerald-800 text-white py-4 rounded-2xl font-black flex items-center justify-center gap-3 hover:bg-emerald-900 transition-all shadow-lg shadow-emerald-800/20">
                  Kirim Pesan <Send size={18} />
                </button>
              </form>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 bg-emerald-100 text-emerald-800 rounded-full flex items-center justify-center mx-auto mb-6">
                  <Send size={32} />
                </div>
                <h3 className="text-2xl font-bold mb-2">Pesan Terkirim!</h3>
                <p className="text-slate-500">Terima kasih, kami akan membalas segera.</p>
              </div>
            )}
          </div>

        </div>
      </main>
    </div>
  );
};

export default ContactPage;